import React from 'react';
import { rem } from 'polished';
import { Button } from 'oxyrion-ui/lib';
import styled from 'styled-components';
import { __, formatDate, FORMAT_HUMANE_DATETIME } from '../../../../Utils';
import { connect, actions } from '../../../../Store';
import API2 from '../../../../API2';
import BaseList from '../../BaseList';
import IconTd from '../../../../Components/ReusableComponents/IconTd';
import CheckAccess from '../../../../ACL/CheckAccess';
import moment from 'moment';

const P = styled.p`
  margin: 0;
  padding: 0 ${rem(10)};
  font-size: ${rem(12)};
  height: ${rem(32)};
  display: flex;
  align-items: center;
`;

class SecurityCertificates extends BaseList {
  constructor(props) {
    super(props);
    this.pageSizes = [10, 20, 50];
    this.defaultLimit = 10;
    this.state = {
      ...this.state,
      title: __('Certifikáty'),
      notFoundMessage: __(
        'Ľutujeme, vyhľadávaniu nezodpovedajú žiadne výsledky ',
      ),
      isProduct: false,
      showPager: false,
      buttonsSwitch: [],
      sorter: '-created_date',
      limit: 10,
      defaultFilter: [
        {
          id: 'type',
          values: ['b2b_contacts'],
        },
      ],
    };
  }

  componentDidMount() {
    const {
      actualPage,
      checkedFilter,
      offset,
      nextOffset,
      total,
    } = this.loadActualData();

    actions.setActiveMenuItem('94');

    let newCheckedFilter =
      checkedFilter && checkedFilter !== 'undefined'
        ? JSON.parse(checkedFilter)
        : [];

    if (!newCheckedFilter || newCheckedFilter.length === 0) {
      newCheckedFilter = this.state.defaultFilter;
    }

    this.setState(
      {
        actualPage:
          actualPage &&
          actualPage !== null &&
          actualPage !== 'null' &&
          actualPage > 0
            ? Number(actualPage)
            : 1,
        offset:
          offset && offset !== null && offset !== 'null' && offset > 0
            ? Number(offset)
            : 0,
        nextOffset:
          nextOffset &&
          nextOffset !== null &&
          nextOffset !== 'null' &&
          nextOffset > 0
            ? Number(nextOffset)
            : 0,
        total:
          total && total !== null && total !== 'null' && total > 0
            ? Number(total)
            : 0,
        checkedFilter: [...newCheckedFilter],
      },
      async () => {
        await this.fetchFilter(false);
        this.fetchData({
          offset:
            offset && offset !== null && offset !== 'null' && offset > 0
              ? Number(offset)
              : 0,
          total,
        });
        this.saveActualData(1, 0, null, [], null);
      },
    );
  }

  async fetchData(parameters = {}) {
    const { limit, checkedFilter, searchText, sorter } = this.state;
    const { firm, user } = this.props;

    try {
      const params = parameters;

      const stateFilter = checkedFilter.find(c => c.id === 'state');
      if (stateFilter) {
        if (
          stateFilter.values.find(f => f === 'Aktívni') &&
          stateFilter.values.length === 1
        )
          params.onlyValid = true;
      }

      if (searchText && searchText.length > 0) {
        params.q = searchText;
      }

      params.sorter = sorter;

      const newData = await API2.getB2BCustomerSecurityCertificatesAction(
        firm,
        user.customer._id,
        Object.assign(params, { limit }),
      );

      this.setState({
        tableItems: newData.items,
        loading: false,
        filtersDisabled: false,
        limit: newData.limit || 0,
        offset: newData.offset || 0,
        total: newData.total || 0,
        nextOffset: newData.next_offset || 0,
      });
    } catch (e) {
      this.setState({
        notFoundMessage: __('Pri načítaní dát sa vyskytla chyba'),
        loading: false,
      });
    }
  }

  handleSorter(s) {
    const { sorter } = this.state;
    let newSorter = sorter;

    if (sorter === s) {
      newSorter = `-${s}`;
    } else {
      newSorter = s;
    }

    this.setState({ sorter: newSorter }, () => this.fetchData());
  }

  onRowClicked(index) {
    // const id = this.state.tableItems[index]._id;
    // this.props.history.push(`/settings/users/${id}`);
  }

  translateApprovalStatus(status) {
    switch (status) {
      case 'APPROVED':
        return __('Schválený');
      case 'WAITING_FOR_APPROVAL':
        return __('Čaká na schválenie');
      case 'DECLINED':
        return __('Zamietnutý');
      default:
        return '-';
    }
  }

  createColumns(sorter) {
    const result = [
      {
        accessor: 'certificateType',
        Header: () => <IconTd>{__('Názov certifikátu')}</IconTd>,
        Cell: props => {
          return <P>{props.value.name}</P>;
        },
      },
      {
        accessor: 'created_date',
        Header: () => <IconTd>{__('Dátum vytvorenia')}</IconTd>,
        Cell: props => {
          return (
            <P>
              {formatDate(moment(props.value), FORMAT_HUMANE_DATETIME) || '-'}
            </P>
          );
        },
      },
      {
        accessor: 'valid_from',
        Header: () => <IconTd>{__('Platný od')}</IconTd>,
        Cell: props => {
          return (
            <P>
              {formatDate(moment(props.value), FORMAT_HUMANE_DATETIME) || '-'}
            </P>
          );
        },
      },
      {
        accessor: 'valid_to',
        Header: () => <IconTd>{__('Platný do')}</IconTd>,
        Cell: props => {
          return (
            <P>
              {formatDate(moment(props.value), FORMAT_HUMANE_DATETIME) || '-'}
            </P>
          );
        },
      },
      {
        accessor: 'approval',
        Header: () => <IconTd>{__('Status')}</IconTd>,
        Cell: props => {
          return <P>{this.translateApprovalStatus(props.value.status)}</P>;
        },
      },
    ];

    return result;
  }

  renderCustomHeaderContent() {
    return (
      <CheckAccess
        operation="postB2BUserAction"
        Component={
          <Button
            style={{ height: rem(15) }}
            icon="plus"
            extrasmall
            primary
            onClick={() =>
              this.props.history.push(`/settings/certificates/new`)
            }
          >
            {__('Vytvoriť')}
          </Button>
        }
      />
    );
  }

  render() {
    return <React.Fragment>{super.render()}</React.Fragment>;
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(SecurityCertificates);



// WEBPACK FOOTER //
// ./src/Containers/Settings/SecurityCertificates/List/index.jsx